
import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, Component, Inject, Input} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {pluralize} from "../../../pipes/pluralize/pluralize";
import { TemplateReplacePipe } from '../../../pipes/trmplate-replace/template-replace.pipe';
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../../config/hotel-tours-list-page.config";

@Component({
    selector: 'app-filter-default',
    templateUrl: environment.mobile ? './filter-default.component.mobile.html' : './filter-default.component.html',
    styleUrls: environment.mobile ? ['./filter-default.component.mobile.scss'] : ['./filter-default.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        TemplateReplacePipe,
    ],
    standalone: true
})
export class FilterDefaultComponent {
  @Input() isActive = false;
  @Input() viewValue!: string;
  @Input() filterValue!: string;
  @Input() count!: number;
  @Input() hideCount = false;
  messages: any = {};

  constructor(@Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig) {
    this.messages = {
      'countTours': '{{countToursVal}} {{countToursText}}',
    };
  }

  countToursMapping(countTours) {
    return {
      'countToursVal': countTours,
      'countToursText': pluralize(countTours, this.hotelToursPageConfig.translates.plurals.pluralTours),
    }
  }
}
